// YouTube-Link aus dem Backoffice → Einbettung ueber youtube-nocookie, wie die
// Live-Seite es tut (#211). Erkannt werden watch?v=, youtu.be/, embed/ und
// shorts/; alles andere ist kein Video und ergibt null.
const ID = '([A-Za-z0-9_-]{6,})'
const MUSTER = [
    new RegExp(`^https?://(?:www\\.)?youtube\\.com/watch\\?(?:.*&)?v=${ID}`),
    new RegExp(`^https?://(?:www\\.)?youtu\\.be/${ID}`),
    new RegExp(`^https?://(?:www\\.)?youtube\\.com/(?:embed|shorts)/${ID}`)
]

export const youtubeEmbedUrl = (link) => {
    for (const muster of MUSTER) {
        const treffer = muster.exec(link || '')
        if (treffer) return `https://www.youtube-nocookie.com/embed/${treffer[1]}`
    }

    return null
}
